// Menu General Ledger
export const MenuGLSetup = [
    {
        Label: 'MainMenu.GLItem1', Icon: 'fa-hand-point-right',
        RouterLink: '/main/gl/account_list',
        Childs: null,
        IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.GLItem2', Icon: 'fa-hand-point-right',
        RouterLink: '/main/gl/acct_class', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.GLItem18', Icon: 'fa-hand-point-right',
        RouterLink: '/main/gl/setup_bs', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.GLItem22', Icon: 'fa-hand-point-right',
        RouterLink: '/main/gl/glpost_description', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    }
];
export const MenuGLInput = [
    {
        Label: 'MainMenu.GLItem34', Icon: 'fa-calculator',
        RouterLink: '/main/gl/gl_tran', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.GLItem3', Icon: 'far fa-keyboard',
        RouterLink: '/main/gl/journal_tran_old', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    }
];
export const MenuGLProcess = [
    {
        Label: 'MainMenu.GLItem4', Icon: 'fa-check-square',
        RouterLink: '/main/gl/closing_period', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.GLItem23', Icon: 'fa-history',
        RouterLink: '/main/gl/unrelease', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.ClosingByMonth', Icon: 'fa-lock',
        RouterLink: '/main/gl/closing_by_month', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    }
];
export const MenuGLInquiry = [
    {
        Label: 'MainMenu.GLItem20', Icon: 'far fa-list-alt',
        RouterLink: '/main/gl/gl_inquiry', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    }
];
export const MenuGLReport = [
    {
        Label: 'MainMenu.GLItem5', Icon: 'fas fa-table',
        RouterLink: '/main/gl/report_gl/rpt_trial_balance', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.GLItem38', Icon: 'fas fa-table',
        RouterLink: '/main/gl/report_gl/rpt_trial_balance_by_period', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.GLItem6', Icon: 'fas fa-book-open',
        RouterLink: '/main/gl/report_gl/rpt_summary_gl', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.GLItem7', Icon: 'fas fa-book',
        RouterLink: '/main/gl/report_gl/rpt_detail_gl', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.GLItem8', Icon: 'fas fa-table',
        RouterLink: '/main/gl/report_gl/rpt_balance_sheet', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.GLItem37', Icon: 'fas fa-table',
        RouterLink: '/main/gl/report_gl/rpt_balance_sheet_by_period', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.GLItem9', Icon: 'fas fa-file-invoice',
        RouterLink: '/main/gl/report_gl/rpt_income_statement', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.GLItem39', Icon: 'fas fa-table',
        RouterLink: '/main/gl/report_gl/rpt_income_statement_by_period', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.cashflow', Icon: 'fas fa-file-invoice',
        RouterLink: '/main/gl/report_gl/rpt_cash_flow', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.GLItem10', Icon: 'fas fa-print',
        RouterLink: '/main/gl/report_gl/rpt_accounts_list', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.GLItem11', Icon: 'fas fa-table',
        RouterLink: '/main/gl/report_gl/rpt_daily_trial_balance', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.GLItem12', Icon: 'fas fa-table',
        RouterLink: '/main/gl/report_gl/rpt_mfgcost', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.GLItem40', Icon: 'fas fa-table',
        RouterLink: '/main/gl/report_gl/rpt_mfgcost_by_period', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.GLItem13', Icon: 'fas fa-table',
        RouterLink: '/main/gl/report_gl/rpt_nonmfgcost', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.GLItem41', Icon: 'fas fa-table',
        RouterLink: '/main/gl/report_gl/rpt_nonmfgcost_by_period', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.GLItem14', Icon: 'fas fa-book',
        RouterLink: '/main/gl/report_gl/rpt_general_journal', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.GLItem15', Icon: 'fas fa-print',
        RouterLink: '/main/gl/report_gl/rpt_print_voucher_acct', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.GLItem27', Icon: 'fas fa-print',
        RouterLink: '/main/gl/report_gl/rpt_daily_cash_balance', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.GLItem21', Icon: 'fas fa-print',
        RouterLink: '/main/gl/report_gl/rpt_closing_entry', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.GLItem29', Icon: 'fas fa-table',
        RouterLink: '/main/gl/report_gl/rpt_mfgcost_detail', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.GLItem30', Icon: 'fas fa-print',
        RouterLink: '/main/gl/report_gl/rpt_income_detail', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.GLItem35', Icon: 'fas fa-print',
        RouterLink: '/main/gl/report_gl/rpt_print_all_payment', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.GLItem36', Icon: 'fas fa-print',
        RouterLink: '/main/gl/report_gl/rpt_print_all_receipt', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    }
];

// Menu Account Payables
export const MenuAPSetup = [
    {
        Label: 'MainMenu.APItem1', Icon: 'fa-hand-point-right',
        RouterLink: '/main/ap/vendor_list', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    }
];
export const MenuAPInput = [
    {
        Label: 'MainMenu.APItem2', Icon: 'fas fa-cash-register',
        RouterLink: '/main/ap/apvoucher', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    }
];
export const MenuAPProcess = [
    {
        Label: 'MainMenu.APItem4', Icon: 'fa-history',
        RouterLink: '/main/ap/ap_release_batches', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    }
];
export const MenuAPInquiry = [
    {
        Label: 'MainMenu.APItem14', Icon: 'fa-hand-point-right',
        RouterLink: '/main/ap/ap_inquiry', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    }
];
export const MenuAPReport = [
    {
        Label: 'MainMenu.APItem5', Icon: 'fas fa-book',
        RouterLink: '/main/ap/report_ap/rpt_ap_detail_by_vend', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.APItem6', Icon: 'fas fa-book',
        RouterLink: '/main/ap/report_ap/rpt_ap_sumary_by_vend', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.APItem7', Icon: 'fas fa-book',
        RouterLink: '/main/ap/report_ap/rpt_general_acct331', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.APItem8', Icon: 'fas fa-chart-line',
        RouterLink: '/main/ap/report_ap/rpt_vendor_list', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.APItem9', Icon: 'fas fa-chart-line',
        RouterLink: '/main/ap/report_ap/rpt_gtgt', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.APItem10', Icon: 'fas fa-chart-line',
        RouterLink: '/main/ap/report_ap/rpt_print_all_payment', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.APItem11', Icon: 'fas fa-chart-line',
        RouterLink: '/main/ap/report_ap/rpt_print_voucher_acct', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.APItem15', Icon: 'fas fa-chart-line',
        RouterLink: '/main/ap/report_ap/rpt_ap_payment', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.APItem16', Icon: 'fas fa-chart-line',
        RouterLink: '/main/ap/report_ap/rpt_payment_voucher', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.APItem17', Icon: 'fas fa-chart-line',
        RouterLink: '/main/ap/report_ap/rpt_overdue', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.APItem18', Icon: 'fas fa-chart-line',
        RouterLink: '/main/ap/report_ap/rpt_aging', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    }
];

// Menu Account Receivables
export const MenuARSetup = [
    {
        Label: 'MainMenu.ARItem1', Icon: 'fa-hand-point-right',
        RouterLink: '/main/ar/customer_list', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    }
];
export const MenuARInput = [
    {
        Label: 'MainMenu.ARItem2', Icon: 'fas fa-keyboard',
        RouterLink: '/main/ar/ar_invoice', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    }
];
export const MenuARProcess = [
    {
        Label: 'MainMenu.ARItem5', Icon: 'fa-history',
        RouterLink: '/main/ar/release_batches', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    }
];
export const MenuARInquiry = [
    {
        Label: 'MainMenu.ARItem12', Icon: 'fa-hand-point-right',
        RouterLink: '/main/ar/ar_inquiry', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    }
];
export const MenuARReport = [
    {
        Label: 'MainMenu.ARItem6', Icon: 'fa-hand-point-right',
        RouterLink: '/main/ar/report_ar/rpt_ar_detail_by_cust', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.ARItem7', Icon: 'fa-hand-point-right',
        RouterLink: '/main/ar/report_ar/rpt_balance_acct131', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.ARItem8', Icon: 'fa-hand-point-right',
        RouterLink: '/main/ar/report_ar/rpt_customer_list', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.ARItem9', Icon: 'fa-hand-point-right',
        RouterLink: '/main/ar/report_ar/rpt_argtgt', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.ARItem10', Icon: 'fa-hand-point-right',
        RouterLink: '/main/ar/report_ar/rpt_print_sheet_all', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.ARItem13', Icon: 'fa-hand-point-right',
        RouterLink: '/main/ar/report_ar/rpt_overdue', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.ARItem14', Icon: 'fa-hand-point-right',
        RouterLink: '/main/ar/report_ar/rpt_aging', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    }
];

// Menu Cash Management
export const MenuCASetup = [
    {
        Label: 'MainMenu.CAItem1', Icon: 'fa-hand-point-right',
        RouterLink: '/main/ca/department', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.CAItem2', Icon: 'fa-hand-point-right',
        RouterLink: '/main/ca/position_list', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.CAItem3', Icon: 'fa-hand-point-right',
        RouterLink: '/main/ca/employee', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    }
];
export const MenuCAInput = [
    {
        Label: 'MainMenu.CAItem4', Icon: 'fa-hand-point-right',
        RouterLink: '/main/ca/ca_payment', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.CAItem5', Icon: 'fa-hand-point-right',
        RouterLink: '/main/ca/ca_receipt', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.CAItem17', Icon: 'fa-hand-point-right',
        RouterLink: 'main/ca/bank_payment', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.CAItem18', Icon: 'fa-hand-point-right',
        RouterLink: 'main/ca/bank_receipt', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    }
];
export const MenuCAProcess = [
    {
        Label: 'MainMenu.CAItem6', Icon: 'fa-history',
        RouterLink: '/main/ca/release_batches', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    // {
    //     Label: 'MainMenu.DiffExchangeRates', Icon: 'fa-hand-point-right',
    //     RouterLink: '/main/ca/diff_exchange_rates', Childs: null, IsChildVisible: false,
    //     GroupName: 'EVERYONE'
    // }
];
export const MenuCAInquiry = [
    {
        Label: 'MainMenu.CAItem16', Icon: 'fa-hand-point-right',
        RouterLink: '/main/ca/ca_inquiry', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    }
];
export const MenuCAReport = [
    {
        Label: 'MainMenu.rptDailyCash', Icon: 'fa-hand-point-right',
        RouterLink: '/main/ca/report_ca/rpt_daily_cash', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.CAItem7', Icon: 'fa-hand-point-right',
        RouterLink: '/main/ca/report_ca/rpt_cash_books', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.CAItem8', Icon: 'fa-hand-point-right',
        RouterLink: '/main/ca/report_ca/rpt_cash_books_detail', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.CAItem9', Icon: 'fa-hand-point-right',
        RouterLink: '/main/ca/report_ca/rpt_trans_detail_by_date', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.CAItem10', Icon: 'fa-hand-point-right',
        RouterLink: '/main/ca/report_ca/rpt_acct141_detail', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.BankBooks', Icon: 'fa-hand-point-right',
        RouterLink: '/main/ca/report_ca/rpt_bank_books', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.CAItem11', Icon: 'fa-hand-point-right',
        RouterLink: '/main/ca/report_ca/rpt_bank_books_detail', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.rptCABankBookUSD_FC', Icon: 'fa-hand-point-right',
        RouterLink: '/main/ca/report_ca/rpt_bank_books_detail_usd', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.CAItem12', Icon: 'fa-hand-point-right',
        RouterLink: '/main/ca/report_ca/rpt_print_all_payment', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.CAItem13', Icon: 'fa-hand-point-right',
        RouterLink: '/main/ca/report_ca/rpt_print_all_receipt', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.CAItem14', Icon: 'fa-hand-point-right',
        RouterLink: '/main/ca/report_ca/rpt_cash_journal', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    }
];

// Menu Fixed Asset
export const MenuFASetup = [
    {
        Label: 'MainMenu.FAItem1', Icon: 'fa-hand-point-right',
        RouterLink: '/main/fa/fa_group', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.FAItem2', Icon: 'fa-hand-point-right',
        RouterLink: '/main/fa/fa_asset', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.FAItem14', Icon: 'fa-hand-point-right',
        RouterLink: '/main/fa/dis_cost_list', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    }
];
export const MenuFAInput = [
    {
        Label: 'MainMenu.FAItem4', Icon: 'fa-hand-point-right',
        RouterLink: '/main/fa/fa_disposal', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.FAItem5', Icon: 'fa-hand-point-right',
        RouterLink: '/main/fa/fa_revalue', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    }
];
export const MenuFAProcess = [
    {
        Label: 'MainMenu.FAItem6', Icon: 'fa-hand-point-right',
        RouterLink: '/main/fa/fa_caldep', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.FAItem12', Icon: 'fa-hand-point-right',
        RouterLink: '/main/fa/cal_allocation', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    }
];
export const MenuFAInquiry = [
    {
        Label: 'MainMenu.FAItem15', Icon: 'fa-hand-point-right',
        RouterLink: '/main/fa/fa_inquiry', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    }
];
export const MenuFAReport = [
    {
        Label: 'MainMenu.FAItem7', Icon: 'fa-hand-point-right',
        RouterLink: '/main/fa/report_fa/rpt_asset_list', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.FAItem8', Icon: 'fa-hand-point-right',
        RouterLink: '/main/fa/report_fa/rpt_monthly_dep', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.FAItem9', Icon: 'fa-hand-point-right',
        RouterLink: '/main/fa/report_fa/rpt_fa_revaluation', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.FAItem10', Icon: 'fa-hand-point-right',
        RouterLink: '/main/fa/report_fa/rpt_statement_detail', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.FAItem11', Icon: 'fa-hand-point-right',
        RouterLink: '/main/fa/report_fa/rpt_allocate_exp', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.FAItem13', Icon: 'fa-hand-point-right',
        RouterLink: '/main/fa/report_fa/rpt_fa_summary', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    }
];

// Menu Inventory
export const MenuINSetup = [
    {
        Label: 'MainMenu.Inven1', Icon: 'fa-hand-point-right',
        RouterLink: 'main/inventory/category', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.Inven2', Icon: 'fa-hand-point-right',
        RouterLink: 'main/inventory/ic_class', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.Inven4', Icon: 'fa-hand-point-right',
        RouterLink: 'main/inventory/ic_site', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.Inven5', Icon: 'fa-hand-point-right',
        RouterLink: 'main/inventory/ic_item', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.Inven3', Icon: 'fa-hand-point-right',
        RouterLink: 'main/inventory/ic_unit', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.InventoryBegin', Icon: 'fa-hand-point-right',
        RouterLink: 'main/inventory/in_begin_balance', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.frmUpdateInvInfor', Icon: 'fa-hand-point-right',
        RouterLink: 'main/inventory/update_inv_infor', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    }
];
export const MenuINInput = [
    {
        Label: 'MainMenu.Inven8', Icon: 'fa-hand-point-right',
        RouterLink: 'main/inventory/icrecr1', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.Inven9', Icon: 'fa-hand-point-right',
        RouterLink: 'main/inventory/icrecr2', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.Inven10', Icon: 'fa-hand-point-right',
        RouterLink: 'main/inventory/icrecr3', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.Inven11', Icon: 'fa-hand-point-right',
        RouterLink: 'main/inventory/icrecr4', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.Inven12', Icon: 'fa-hand-point-right',
        RouterLink: 'main/inventory/icissues1', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.Inven13', Icon: 'fa-hand-point-right',
        RouterLink: 'main/inventory/icissues2', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.Inven14', Icon: 'fa-hand-point-right',
        RouterLink: 'main/inventory/icissues3', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.Inven15', Icon: 'fa-hand-point-right',
        RouterLink: 'main/inventory/icissues4', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.Inven16', Icon: 'fa-hand-point-right',
        RouterLink: 'main/inventory/icadjustment', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    // {
    //     Label: 'MainMenu.Incomplete', Icon: 'fa-hand-point-right',
    //     RouterLink: null, Childs: null, IsChildVisible: false,
    //     GroupName: 'EVERYONE'
    // }
];
export const MenuINProcess = [
    {
        Label: 'MainMenu.Inventoryprocess', Icon: 'fa-hand-point-right',
        RouterLink: 'main/inventory/process_inventory/process', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.ICRlsedBatches', Icon: 'fa-hand-point-right',
        RouterLink: 'main/inventory/process_inventory/release_batches2', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    }
];
export const MenuINReport = [
    {
        Label: 'MainMenu.Inven24', Icon: 'fa-hand-point-right',
        RouterLink: 'main/inventory/report_in/inventory_status', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.Inven25', Icon: 'fa-hand-point-right',
        RouterLink: 'main/inventory/report_in/inventory_movement', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.Inven26', Icon: 'fa-hand-point-right',
        RouterLink: 'main/inventory/report_in/inventory_transaction', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.Inven27', Icon: 'fa-hand-point-right',
        RouterLink: 'main/inventory/report_in/raw_material_consumption', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.Inven28', Icon: 'fa-hand-point-right',
        RouterLink: 'main/inventory/report_in/manufacturing', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.Inven29', Icon: 'fa-hand-point-right',
        RouterLink: 'main/inventory/report_in/costing_spread_sheet', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.Inven30', Icon: 'fa-hand-point-right',
        RouterLink: 'main/inventory/report_in/item_listing', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.DetailsIncome', Icon: 'fa-hand-point-right',
        RouterLink: 'main/inventory/report_in/details_income', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.SummaryIncome', Icon: 'fa-hand-point-right',
        RouterLink: 'main/inventory/report_in/summary_income', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.ReturnR1', Icon: 'fa-hand-point-right',
        RouterLink: 'main/inventory/report_in/return_r1', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.SummaryReceiptMaterial', Icon: 'fa-hand-point-right',
        RouterLink: 'main/inventory/report_in/summary_receipt', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.SummaryIssueMaterial', Icon: 'fa-hand-point-right',
        RouterLink: 'main/inventory/report_in/summary_issue', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.GLItem15', Icon: 'fa-hand-point-right',
        RouterLink: 'main/inventory/report_in/print_sheet_all', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.Item154', Icon: 'fa-hand-point-right',
        RouterLink: 'main/inventory/report_in/wip_finish_goods', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    }
];
// Menu Tax Invoice
export const MenuSASetup = [
    {
        Label: 'MainMenu.IssueInvoice', Icon: 'fa-hand-point-right',
        RouterLink: '/main/sa/invoice', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.CancelInvoice', Icon: 'fa-hand-point-right',
        RouterLink: '/main/sa/cancelinvoice', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.LostBadInvoices', Icon: 'fa-hand-point-right',
        RouterLink: '/main/sa/lostbadinvoice', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    }
];
export const MenuSAInput = [
    {
        Label: 'MainMenu.PXKKVCNB', Icon: 'fa-hand-point-right',
        RouterLink: '/main/sa/xuatkho_vcnb', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    // {
    //     Label: 'MainMenu.CancelInvoice', Icon: 'fa-hand-point-right',
    //     RouterLink: '/main/sa/cancel_invoice', Childs: null, IsChildVisible: false,
    //     GroupName: 'EVERYONE'
    // },
    {
        Label: 'MainMenu.ListInvoices', Icon: 'fa-hand-point-right',
        RouterLink: '/main/sa/listinvoice', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.CheckInvoice', Icon: 'fa-hand-point-right',
        RouterLink: '/main/sa/check_invoice', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    }
];
export const MenuSAReport = [
    {
        Label: 'MainMenu.IssueInvoiceReport', Icon: 'fa-hand-point-right',
        RouterLink: '/main/sa/report_sa/rpt_issue', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.LostFireCorrupt', Icon: 'fa-hand-point-right',
        RouterLink: '/main/sa/report_sa/rpt_lost', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.CancelInvoiceReport', Icon: 'fa-hand-point-right',
        RouterLink: '/main/sa/report_sa/rpt_cancel', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.TheUseOfInvoiceReport', Icon: 'fa-hand-point-right',
        RouterLink: '/main/sa/report_sa/the_use_of_invoice', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    }
];


// Menu E Invoice
export const MenuEISetup = [
    {
        Label: 'MainMenu.EIServiceProvider', Icon: 'fa-hand-point-right',
        RouterLink: '/main/ei/service_provider', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.EIServiceAccount', Icon: 'fa-hand-point-right',
        RouterLink: '/main/ei/service_account', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.EIUserAccount', Icon: 'fa-hand-point-right',
        RouterLink: '/main/ei/user_account', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.EISerialRegistration', Icon: 'fa-hand-point-right',
        RouterLink: '/main/ei/serial_registration', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    }
];
export const MenuEIInput = [
    {
        Label: 'MainMenu.EIInput', Icon: 'fa-hand-point-right',
        RouterLink: '/main/ei/ei_input', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.EIRelease2EI', Icon: 'fa-hand-point-right',
        RouterLink: '/main/ei/voucher_release_ei', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.ReleaseEI', Icon: 'fa-hand-point-right',
        RouterLink: '/main/ei/release_batches', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    }
];
export const MenuEIProcess = [
    {
        Label: 'MainMenu.EIInvoicePublishing', Icon: 'fa-hand-point-right',
        RouterLink: '/main/ei/invoice_publishing', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.EIInvoiceTracking', Icon: 'fa-hand-point-right',
        RouterLink: '/main/ei/invoice_tracking', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    // {
    //     Label: 'MainMenu.EITrackingViettel', Icon: 'fa-hand-point-right',
    //     RouterLink: '/main/ei/tracking_viettel', Childs: null, IsChildVisible: false,
    //     GroupName: 'EVERYONE'
    // }
];

// Menu Purchase Order
export const MenuPOInput = [
    {
        Label: 'MainMenu.PurchaseOrder', Icon: 'fa-hand-point-right',
        RouterLink: '/main/po/purchase_order', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    }
];
export const MenuPOProcess = [
    {
        Label: 'MainMenu.PORlsedBatches', Icon: 'fa-hand-point-right',
        RouterLink: '/main/po/po_releasebatches', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.ApprovedPOBatches', Icon: 'fa-hand-point-right',
        RouterLink: '/main/po/approvedbatches', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    }
];
export const MenuPOReport = [
    {
        Label: 'MainMenu.POReport', Icon: 'fa-hand-point-right',
        RouterLink: '/main/po/rpt_puchaseorder', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    }
];

// Menu Sale Order
export const MenuSOInput = [
    {
        Label: 'MainMenu.SOsaleOrder', Icon: 'fa-hand-point-right',
        RouterLink: '/main/so/sale_order', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    }
];
export const MenuSOProcess = [
    {
        Label: 'MainMenu.SORlsedBatches', Icon: 'fa-hand-point-right',
        RouterLink: '/main/so/releasebatches', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.ApprovedSOBatches', Icon: 'fa-hand-point-right',
        RouterLink: '/main/so/approvedbatches', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    }
];
export const MenuSOReport = [
    {
        Label: 'MainMenu.SOReport', Icon: 'fa-hand-point-right',
        RouterLink: '/main/so/rpt_saleorder', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    }
];
// Menu Budget
export const MenuBGInput = [
    {
        Label: 'MainMenu.SetupBG', Icon: 'fa-hand-point-right',
        RouterLink: '/main/bg/budget_input', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    }
];
export const MenuBGReport = [
    {
        Label: 'MainMenu.ReportBG', Icon: 'fa-hand-point-right',
        RouterLink: '/main/bg/budget_report', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    }
];
// Menu Shared Information
export const MenuSIInput = [
    {
        Label: 'MainMenu.Item1', Icon: 'fa-hand-point-right',
        RouterLink: '/main/general/tax_maintenance', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.Item2', Icon: 'fa-hand-point-right',
        RouterLink: '/main/general/currency_maintenance', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.Item3', Icon: 'fa-hand-point-right',
        RouterLink: '/main/general/terms_maintenance', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.Item4', Icon: 'fa-hand-point-right',
        RouterLink: '/main/general/acct_module', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.Item5', Icon: 'fa-hand-point-right',
        RouterLink: '/main/general/dept_begin_balance', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.Item10', Icon: 'fa-hand-point-right',
        RouterLink: '/main/general/costcenters', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.Item11', Icon: 'fa-hand-point-right',
        RouterLink: '/main/general/jobcenters', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.Item12', Icon: 'fa-hand-point-right',
        RouterLink: '/main/general/profitcenters', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.Item14', Icon: 'fa-hand-point-right',
        RouterLink: 'main/general/config_team', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.Item15', Icon: 'fa-hand-point-right',
        RouterLink: 'main/general/job_center_by_config_team', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    }
];

// Menu Userfull
export const MenuUFInput = [
    {
        Label: 'MainMenu.SortVouchers', Icon: 'fa-hand-point-right',
        RouterLink: 'main/use_full/sort_vouchers', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.CheckVouchers', Icon: 'fa-hand-point-right',
        RouterLink: 'main/use_full/check_vouchers', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.CheckVouchersDoubleOnGL', Icon: 'fa-hand-point-right',
        RouterLink: 'main/general/double_vouchers', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.CheckingAcountCustomer', Icon: 'fa-hand-point-right',
        RouterLink: 'main/use_full/check_acct_customer', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.CheckingAcountVendor', Icon: 'fa-hand-point-right',
        RouterLink: 'main/use_full/check_acct_vendor', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    }
];
// Menu Setup Tools
export const MenuSTSetup = [
    {
        Label: 'List of tax rates', Icon: 'fa-hand-point-right',
        RouterLink: null, Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'List of currencies', Icon: 'fa-hand-point-right',
        RouterLink: null, Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'Exchange Rate', Icon: 'fa-hand-point-right',
        RouterLink: null, Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'List of payable terms', Icon: 'fa-hand-point-right',
        RouterLink: null, Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'Account Access Permission', Icon: 'fa-hand-point-right',
        RouterLink: null, Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'An opening balance', Icon: 'fa-hand-point-right',
        RouterLink: null, Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    }
];

export const MenuSTSecurity = [
    // {
    //     Label: 'MainMenu.cmdUser', Icon: 'fa-hand-point-right',
    //     RouterLink: null, Childs: null, IsChildVisible: false,
    //     GroupName: 'EVERYONE'
    // },
    // {
    //     Label: 'MainMenu.cmdGroup', Icon: 'fa-hand-point-right',
    //     RouterLink: null, Childs: null, IsChildVisible: false,
    //     GroupName: 'EVERYONE'
    // },
    {
        Label: 'MainMenu.cmdConfiguration', Icon: 'fa-hand-point-right',
        RouterLink: '/main/setup_tools/configuration_values', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.cmdAccessRightsModule', Icon: 'fa-hand-point-right',
        RouterLink: '/main/setup_tools/right_access_module', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.cmdChangepwd', Icon: 'fa-hand-point-right',
        RouterLink: '/main/setup_tools/reset_pw', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.cmdCompany', Icon: 'fa-hand-point-right',
        RouterLink: '/main/setup_tools/company_infor', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.cmdScreen', Icon: 'fa-hand-point-right',
        RouterLink: '/main/setup_tools/screen', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.cmdAccessRightsForm', Icon: 'fa-hand-point-right',
        RouterLink: '/main/setup_tools/right_access_form', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    }
];

// Menu Approve System
export const MenuSPInput = [
    {
        Label: 'MainMenu.ApprovalSetupRight', Icon: 'fa-hand-point-right',
        RouterLink: '/main/sp/approval_setup_right', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.RequestForPayment', Icon: 'fa-hand-point-right',
        RouterLink: '/main/sp/request_for_payment', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.ApprovalForPayment', Icon: 'fa-hand-point-right',
        RouterLink: '/main/sp/approval_for_payment', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.Payable', Icon: 'fa-hand-point-right',
        RouterLink: '/main/sp/payable', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.TravelRequest', Icon: 'fa-hand-point-right',
        RouterLink: '/main/sp/request_for_payment', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.LeaveRequest', Icon: 'fa-hand-point-right',
        RouterLink: '/main/sp/request_for_payment', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.CashierBeginBalance', Icon: 'fa-hand-point-right',
        RouterLink: '/main/sp/cashier_begin_balance', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MainMenu.CashierBookReceive', Icon: 'fa-hand-point-right',
        RouterLink: '/main/sp/cashier_book_receive', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    }
];

export const MenuSPReport = [
    {
        Label: 'MainMenu.DailyCashReport', Icon: 'fa-hand-point-right',
        RouterLink: '/main/sp/rpt_daily_cash', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    }
];

// Menu Customer Portal

export const MenuCPFinancialStatement = [
    {
        Label: 'MenuCP.AnalyzeDashboard', Icon: 'fa-hand-point-right',
        RouterLink: '/main/cp/analyze/dashboard', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MenuCP.BalanceSheet', Icon: 'fa-hand-point-right',
        RouterLink: '/main/cp/analyze/balance_sheet', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    
    {
        Label: 'MenuCP.IncStatementPeriod', Icon: 'fa-hand-point-right',
        RouterLink: '/main/cp/analyze/inc_statement_period', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
];

export const MenuCPCustomers = [
    {
        Label: 'MenuCP.CustomerDashboard', Icon: 'fa-hand-point-right',
        RouterLink: '/main/cp/customer/dashboard',
        Childs: null,
        IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MenuCP.CustomerList', Icon: 'fa-hand-point-right',
        RouterLink: '/main/cp/customer/customer_list', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MenuCP.CustomerDetail', Icon: 'fa-hand-point-right',
        RouterLink: '/main/cp/customer/customer_detail', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MenuCP.ReceivableCustomer', Icon: 'fa-hand-point-right',
        RouterLink: '/main/cp/analyze/receivable_customer',
        Childs: null,
        IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
];

export const MenuCPVendors = [
    {
        Label: 'MenuCP.VendorDashboard', Icon: 'fa-hand-point-right',
        RouterLink: '/main/cp/vendor/dashboard',
        Childs: null,
        IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MenuCP.VendorList', Icon: 'fa-hand-point-right',
        RouterLink: '/main/cp/vendor/vendor_list', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MenuCP.VendorDetail', Icon: 'fa-hand-point-right',
        RouterLink: '/main/cp/vendor/vendor_detail', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MenuCP.PayableToVendor', Icon: 'fa-hand-point-right',
        RouterLink: '/main/cp/analyze/payable_to_vendor', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
];

export const MenuCPRevenues = [
    {
        Label: 'MenuCP.RevenueDashboard', Icon: 'fa-hand-point-right',
        RouterLink: '/main/cp/revenue/dashboard',
        Childs: null,
        IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MenuCP.RevenueDetail', Icon: 'fa-hand-point-right',
        RouterLink: '/main/cp/revenue/revenue_detail', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
];

export const MenuCPCost = [
    {
        Label: 'MenuCP.CostDashboard', Icon: 'fa-hand-point-right',
        RouterLink: '/main/cp/cost/dashboard',
        Childs: null,
        IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MenuCP.CostDetail', Icon: 'fa-hand-point-right',
        RouterLink: '/main/cp/cost/cost_detail', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
];

export const MenuCPAnalyze = [
    {
        Label: 'MenuCP.StockYTD', Icon: 'fa-hand-point-right',
        RouterLink: '/main/cp/analyze/stock_ytd', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MenuCP.SalesYTDByProduct', Icon: 'fa-hand-point-right',
        RouterLink: '/main/cp/analyze/sales_ytd_by_product', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MenuCP.SalesYTDByCustomer', Icon: 'fa-hand-point-right',
        RouterLink: '/main/cp/analyze/sales_ytd_by_customer', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MenuCP.SalesMTDByProduct', Icon: 'fa-hand-point-right',
        RouterLink: '/main/cp/analyze/sales_mtd_by_product', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MenuCP.PurYTDByProduct', Icon: 'fa-hand-point-right',
        RouterLink: '/main/cp/analyze/pur_ytd_by_product', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MenuCP.PurYTDByVendor', Icon: 'fa-hand-point-right',
        RouterLink: '/main/cp/analyze/pur_ytd_by_vendor', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MenuCP.PurMTDByProduct', Icon: 'fa-hand-point-right',
        RouterLink: '/main/cp/analyze/pur_mtd_by_product', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    // {
    //     Label: 'MenuCP.ProductSite', Icon: 'fa-hand-point-right',
    //     RouterLink: '/main/cp/management/product_site', Childs: null, IsChildVisible: false,
    //     GroupName: 'EVERYONE'
    // },
    {
        Label: 'MenuCP.ProductClass', Icon: 'fa-hand-point-right',
        RouterLink: '/main/cp/management/product_class', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MenuCP.Products', Icon: 'fa-hand-point-right',
        RouterLink: '/main/cp/management/products', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MenuCP.InventoriesRatios', Icon: 'fa-hand-point-right',
        RouterLink: '/main/cp/analyze/inventories_ratios', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    }
];

export const MenuCPManagements = [
    // {
    //     Label: 'MenuCP.ClientList', Icon: 'fa-hand-point-right',
    //     RouterLink: '/main/cp/management/client_list', Childs: null, IsChildVisible: false,
    //     GroupName: 'EVERYONE'
    // },
    {
        Label: 'MenuCP.AdvancesToEmployee', Icon: 'fa-hand-point-right',
        RouterLink: '/main/cp/analyze/advances_to_employee',
        Childs: null,
        IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MenuCP.CashBook', Icon: 'fa-hand-point-right',
        RouterLink: '/main/cp/analyze/cash_book',
        Childs: null,
        IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MenuCP.CashBookMTD', Icon: 'fa-hand-point-right',
        RouterLink: '/main/cp/analyze/cash_book_mtd', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    // {
    //     Label: 'MenuCP.Employee', Icon: 'fa-hand-point-right',
    //     RouterLink: '/main/cp/management/employee', Childs: null, IsChildVisible: false,
    //     GroupName: 'EVERYONE'
    // }
];

export const MenuCPHumanResources = [
    {
        Label: 'MenuCP.HRDashboard', Icon: 'fa-hand-point-right',
        RouterLink: '/main/cp/hr/hr_dashboard', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MenuCP.HREmployee', Icon: 'fa-hand-point-right',
        RouterLink: '/main/cp/hr/hr_employee', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MenuCP.HRDepartment', Icon: 'fa-hand-point-right',
        RouterLink: '/main/cp/hr/hr_department', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    },
    {
        Label: 'MenuCP.HROrgChart', Icon: 'fa-hand-point-right',
        RouterLink: '/main/cp/hr/hr_org_chart', Childs: null, IsChildVisible: false,
        GroupName: 'EVERYONE'
    }
];
